const streakProtection = {
  en: {
    title: 'Streak protection', timezone: 'Calendar time zone: {timezone}',
    vacationRemaining: 'Vacation {remaining}/{limit}', superpassRemaining: 'Superpass {remaining}/{limit}',
    vacationReserved: 'Vacation reserved', vacationUsed: 'Vacation day', superpassUsed: 'Superpass used',
    reserve: 'Reserve vacation', cancel: 'Cancel vacation', saving: 'Saving…', close: 'Close date menu',
    dateMenu: '{date} — streak protection', selectDate: 'View {date}',
    futureHint: 'Reserve by the previous day. Up to four days per month.',
    readOnly: 'Vacation can only be reserved or canceled before the day begins.',
    quotaReached: 'All four vacation days for this month are reserved or used.',
    studyDay: 'You trained on this day.', noProtection: 'No streak protection on this day.',
    saveFailed: 'Could not update vacation. Try again.', beep: 'Beep on vacation',
  },
  ko: {
    title: '연속 학습 보호', timezone: '캘린더 기준 시간대: {timezone}',
    vacationRemaining: '휴가 {remaining}/{limit}', superpassRemaining: '슈퍼패스 {remaining}/{limit}',
    vacationReserved: '휴가 예약', vacationUsed: '휴가 사용', superpassUsed: '슈퍼패스 사용',
    reserve: '휴가 신청', cancel: '휴가 철회', saving: '저장 중…', close: '날짜 메뉴 닫기',
    dateMenu: '{date} — 연속 학습 보호', selectDate: '{date} 확인',
    futureHint: '휴가 전날까지 신청할 수 있어요. 한 달에 최대 4일이에요.',
    readOnly: '휴가 신청과 철회는 해당 날짜가 시작되기 전에만 가능해요.',
    quotaReached: '이번 달 휴가 4일을 모두 예약하거나 사용했어요.',
    studyDay: '학습한 날이에요.', noProtection: '연속 학습 보호 내역이 없어요.',
    saveFailed: '휴가를 변경하지 못했어요. 다시 시도해 주세요.', beep: '휴가 중인 Beep',
  },
};

export default streakProtection;
